import orderBy from 'lodash/fp/orderBy';
import { orderBy as naturalOrderBy } from 'natural-orderby';
export var SortDirection = {
  ASCENDING: 'asc',
  DESCENDING: 'desc'
};
var toLowerCaseProp = function toLowerCaseProp(element, prop) {
  if (typeof element[prop] === 'string') {
    return element[prop].toLowerCase();
  }
  return element[prop];
};
export function sortByProperty(array, property) {
  var sortDirection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SortDirection.ASCENDING;
  var isCaseSensitiv = arguments.length > 3 ? arguments[3] : undefined;
  if (!isCaseSensitiv) {
    return orderBy(function (element) {
      return toLowerCaseProp(element, property);
    }, sortDirection, array);
  }
  return orderBy(property, sortDirection, array);
}
export function naturalSortByProperty(array, property) {
  var sortDirection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SortDirection.ASCENDING;
  var isCaseSensitiv = arguments.length > 3 ? arguments[3] : undefined;
  if (!isCaseSensitiv) {
    return naturalOrderBy(array, function (element) {
      return toLowerCaseProp(element, property);
    }, sortDirection);
  }
  return naturalOrderBy(array, property, sortDirection);
}